import React, { type JSX, Suspense, lazy } from 'react'
import { setHostHelpers } from '@mobi/account/Areas/Statements/Utils/hostHelpers'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { useDisableAppHeaderSticky } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderSticky'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { UpdateAccountBalance } from '@core/State/UserAccount/userAccountDriver'
import { triggerHapticFeedback } from '@core/Utils/hapticFeedback/hapticFeedback'
import { useRefreshOnBetPlaced } from '../Activity/Components/Main/hooks'
import { useAccountTransactionsData } from './hooks/useAccountTransactionsData'

const App = lazy(() => import('@mobi/account/Areas/Statements/Components/App'))

export const StatementsPage = (): JSX.Element | null => {
  const { accountNumber } = useAuthenticatedAccount()
  useDisableAppHeaderSticky()

  setHostHelpers({
    triggerHapticFeedback,
    useRefreshOnBetPlaced,
    useAccountTransactionsData,
    clearTransactionsCache: (selectedDate: string) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.accountTransactions(selectedDate) })
    },
    updateAccountBalance: (balance?: { balance: string | number }) => {
      UpdateAccountBalance(balance)
    },
  })

  return (
    <Suspense fallback={<Spinner />}>
      <App betAccountNumber={accountNumber} />
    </Suspense>
  )
}
